import { useCallback } from 'react';
import { get, post } from '../../../../components/hooks/apiFetch';

export const useUserPreferences = () => {

    const getPreferences = useCallback(async (utility) => {
        try {
            const userPreferences = await get(`/api/userPreferences?utility=${utility}`);
            return userPreferences;
        } catch (error) {
            if (error.response && error.response.status === 404) {
                return null; // предпочтений нет
            }
            throw error.message;
        }
    }, [get]);

    const savePreferences = useCallback(async (utility, preferences) => {
        await post(`/api/userPreferences?utility=${utility}`, preferences);
    }, [post]);

    return { getPreferences, savePreferences };
};